
import dialogMessages from 'ui/Dialog/messages';
import messages from './messages/sinkFasteningMessages';
import PictogramFasteningTopMounted from './images/sinks/picto_SINK_TopMounted.png';
import ImageFasteningTopMounted from './images/sinks/Sink_Inset.png';
import ImageFasteningTopMountedNoOverflow from './images/sinks/Sink_Inset_noOverflow.png';
import PictogramFasteningUnderGlued from './images/sinks/picto_SINK_UnderGlued.png';
import ImageFasteningUnderGlued from './images/sinks/Sink_Underglued.png';
import ImageFasteningUnderGluedNoOverflow from './images/sinks/Sink_Underglued_noOverflow.png';
import PictogramFasteningFitBetween from './images/sinks/picto_SINK_FitBetween.png';
import ImageFasteningFitBetween from './images/sinks/Sink_Onset.png';
import ImageFasteningFitBetweenNoOverflow from './images/sinks/Sink_Onset_noOverflow.png';
import * as fasteningAnimations from './images/sinks/fastenings/animations';

export function generateSinkFastenings(hideOverflowHoles = false) {
  return [
    {
      id: 'topMounted',
      displayName: messages.topMounted,
      summaryTitle: messages.insetSinkTitle,
      displayImage: hideOverflowHoles ? ImageFasteningTopMountedNoOverflow : ImageFasteningTopMounted,
      displayImageLarge: hideOverflowHoles ? fasteningAnimations.InsetWithoutOverflow : fasteningAnimations.Inset,
      pictogramImage: PictogramFasteningTopMounted,
      info:
      [
        { id: 'basic', title: dialogMessages.basicFeatures, text: messages.topMountedInfo },
      ],
    },
    {
      id: 'underGlued',
      displayName: messages.underGlued,
      summaryTitle: messages.undergluedSinkTitle,
      displayImage: hideOverflowHoles ? ImageFasteningUnderGluedNoOverflow : ImageFasteningUnderGlued,
      displayImageLarge: hideOverflowHoles ? fasteningAnimations.UnderGluedWithoutOverflow : fasteningAnimations.UnderGlued,
      pictogramImage: PictogramFasteningUnderGlued,
      info:
      [
        { id: 'basic', title: dialogMessages.basicFeatures, text: messages.underGluedInfo },
      ],
    },
    {
      id: 'fitBetween',
      displayName: messages.fitBetween,
      summaryTitle: messages.onsetSinkTitle,
      displayImage: hideOverflowHoles ? ImageFasteningFitBetweenNoOverflow : ImageFasteningFitBetween,
      displayImageLarge: hideOverflowHoles ? fasteningAnimations.OnsetWithoutOverflow : fasteningAnimations.Onset,
      pictogramImage: PictogramFasteningFitBetween,
      info: [
        { id: 'basic', title: dialogMessages.basicFeatures, text: messages.fitBetweenInfo },
      ],
    },
  ];
}
